// extracted by mini-css-extract-plugin
export var backupIcon = "_mx-1";
export var image = "_mx-0";